import { render, staticRenderFns } from "./new_declaration_vh_fc.vue?vue&type=template&id=720f9d65&scoped=true"
import script from "./new_declaration_vh_fc.vue?vue&type=script&lang=js"
export * from "./new_declaration_vh_fc.vue?vue&type=script&lang=js"
import style0 from "./new_declaration_vh_fc.vue?vue&type=style&index=0&id=720f9d65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720f9d65",
  null
  
)

export default component.exports